import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'
import * as Yup from 'yup'

const retornaQuarto = (u = []) => ({
  idQuarto: u?.[0] || undefined,
  cdQuarto: u?.[1] || undefined,
  dsQuarto: u?.[2] || undefined,
  dtInclusao: u?.[3] || undefined,
  dtExclusao: u?.[4] || undefined,
})

const validationSchema = Yup.object({
  cdQuarto: Yup.string().required('Campo Obrigatório!'),
  dsQuarto: Yup.string().required('Campo Obrigatório!'),
})

const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const payload = {
      ...values,
      cdQuarto: values.cdQuarto.toUpperCase(),
    }
    const res = await metodoPrograma('salva', payload)
    if (res.status) voltar()
    else setError(res.dsErro)
  }

  return (
    <Formik
      initialValues={retornaQuarto(dados)}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="cdQuarto"
                label="Código"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                inputProps={{ style: { textTransform: 'uppercase' } }}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                rows={4}
                multiline
                name="dsQuarto"
                label="Descrição"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
